<template>
    <span id="selectWrapper">
        <div id="selectTrigger" ref="selectTrigger" @click.stop="open">
            <div ref="trigger" :style="trigger_style">
                <slot name="trigger"></slot>
            </div>
        </div>
        <div
            id="selectMenu"
            ref="selectMenu"
            v-if="menu.open"
            :style="{ ...menu_style, top: `${menu.top}px`, left: `${menu.left}px` }"
        >
            <slot name="options"></slot>
        </div>
    </span>
</template>

<script>
export default {
    data() {
        return {
            menu: {
                open: false,
                top: 0,
                left: 0
            }
        };
    },
    props: {
        trigger_style: {
            type: Object,
            required: false
        },
        menu_style: {
            type: Object,
            required: false,
            default: () => {
                return {};
            }
        },
        menu_offset: {
            type: Object,
            required: false,
            default: () => {
                return { top: 0, left: 0 };
            }
        }
    },
    methods: {
        open() {
            this.position();
            this.menu.open = true;

            if (!this.menu_style.width) {
                this.$nextTick(() => {
                    const parentRect = this.$refs.selectMenu.parentElement.getBoundingClientRect();
                    this.$refs.selectMenu.style.width = parentRect.width + "px";
                });
            }

            document.addEventListener("click", this.close, true);
        },
        close() {
            this.menu.open = false;

            document.removeEventListener("click", this.close, true);
        },
        position() {
            // const triggerRect = this.$refs.trigger.getBoundingClientRect();

            // this.menu.top = triggerRect.top;
            // this.menu.left = triggerRect.left;

            this.menu.top = 0;
            this.menu.left = 0;

            if (this.menu_offset.top) this.menu.top += this.menu_offset.top;
            if (this.menu_offset.left) this.menu.left += this.menu_offset.left;
        }
    },
    beforeDestroy() {
        document.removeEventListener("click", this.close, true);
    }
};
</script>

<style scoped>
#selectWrapper {
    position: relative;
}

#selectTrigger {
    cursor: pointer;
}

#selectMenu {
    position: absolute;

    max-height: 368px;

    overflow-y: scroll;
    background-color: white;
    padding: 8px 0;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 16px 16px rgba(35, 38, 43, 0.24);
    /* z-index: 999; */
}
#selectMenu > * {
    width: 100%;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 24px;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    color: var(--light-black);
    cursor: pointer;
    text-decoration: none;
}

#selectMenu > *:hover {
    background-color: var(--light-blue);
}
</style>
